<template>
	<b-container fluid class="px-1">    
	    <b-row class="justify-content-center mx-0">
	      <h1 style="text-align: center;">Cookies Policy</h1>
	    </b-row>
      <b-row class="justify-content-center mx-0 pl-4 pr-4">
        <p style="padding-left: 10%; padding-right: 10%;">

          Last updated: January 09, 2021<br><br>

          This Cookies Policy explains what Cookies are and how We use them. You should read this policy so You can understand what type of cookies We use, or the information We collect using Cookies and how that information is used. <br><br>

          Cookies do not typically contain any information that personally identifies a user, but personal information that we store about You may be linked to the information stored in and obtained from Cookies. For further information on how We use, store and keep your personal data secure, see our Privacy Policy.<br><br>

          We do not store sensitive personal information, such as mailing addresses, account passwords, etc. in the Cookies We use.<br><br>

          Interpretation and Definitions:<br><br>
          Interpretation:<br>
          The words of which the initial letter is capitalized have meanings defined under the following conditions. The following definitions shall have the same meaning regardless of whether they appear in singular or in plural.<br><br>

          Definitions:<br>
          For the purposes of this Cookies Policy:<br>

          Company (referred to as either “Silverdor”, “We”, “Us” or “Our” in this Cookies Policy) refers to Silverdor.<br>
          Cookies means small files that are placed on Your computer, mobile device or any other device by a website, containing details of your browsing history on that website among its many uses.<br>
          Website refers to Silverdor, accessible from https://silverdor.com<br>
          You means the individual accessing or using the Website, or a company, or any legal entity on behalf of which such individual is accessing or using the Website, as applicable.<br>
          The use of the Cookies:<br>
          Type of Cookies We Use:<br>
          Cookies can be “Persistent” or “Session” Cookies. Persistent Cookies remain on your personal computer or mobile device when You go offline, while Session Cookies are deleted as soon as You close your web browser.<br><br>

          We use both session and persistent Cookies for the purposes set out below:<br>

          Necessary / Essential Cookies<br>

          Type: Session Cookies<br>

          Administered by: Us<br><br>

          Purpose: These Cookies are essential to provide You with services available through the Website and to enable You to use some of its features. They help to authenticate users and prevent fraudulent use of user accounts. Without these Cookies, the services that You have asked for cannot be provided, and We only use these Cookies to provide You with those services.<br><br>

          Functionality Cookies:<br>

          Type: Persistent Cookies<br>

          Administered by: Us<br>

          Purpose: These Cookies allow us to remember choices You make when You use the Website, such as remembering your login details or language preference. The purpose of these Cookies is to provide You with a more personal experience and to avoid You having to re-enter your preferences every time You use the Website.<br><br>

          Your Choices Regarding Cookies:<br><br>
          If You prefer to avoid the use of Cookies on the Website, first You must disable the use of Cookies in your browser and then delete the Cookies saved in your browser associated with this website. You may use this option for preventing the use of Cookies at any time.<br><br>

          If You do not accept Our Cookies, You may experience some inconvenience in your use of the Website and some features may not function properly.<br><br>

          If You’d like to delete Cookies or instruct your web browser to delete or refuse Cookies, please visit the help pages of your web browser.<br><br>

          For the Chrome web browser, please visit this page from Google: https://support.google.com/<br><br>

          For the Internet Explorer web browser, please visit this page from Microsoft: http://support.microsoft.com/<br><br>

          For the Firefox web browser, please visit this page from Mozilla: <br>https://support.mozilla.org/<br><br>

          For the Safari web browser, please visit this page from Apple: https://support.apple.com/<br><br>

          For any other web browser, please visit your web browser’s official web pages.<br><br>

          More Information about Cookies:<br>
          You can learn more about cookies by using Google or Youtube videos.<br><br>

          Contact Us<br>
          If you have any questions about this Cookies Policy, You can contact us:<br>

          By visiting this page on our website: https://silverdor.com/support<br>
        </p>
      </b-row>
	</b-container> 
</template>

<script>
export default {
 
  data() {
    return {
      visible: false
    };
  },

  methods:{
 
  },

  components: { 
  },

  computed: {
  }
};
</script>
<style scoped>


</style>